import React from "react";

function AdmNoField({ value, onChange, error }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
      <label
        htmlFor="AdmNo1"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
       <select
  name="selection3"
  value={value.selection3}
  onChange={onChange}
  style={{
    flex: "1",
    minWidth: "50px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ffa726", // Orange border
    fontSize: "1rem",
    background: "linear-gradient(135deg, #fff3e0, #ffcc80)", // Orange gradient
    color: "#ef6c00", // Orange font color

    // ❌ Removed to restore native arrow
    // appearance: "none",
    // WebkitAppearance: "none",
    // MozAppearance: "none",

    boxShadow: "0px 4px 8px rgba(255, 167, 38, 0.4)", // Light orange shadow
    transition: "background-color 0.3s ease",
    cursor: "pointer",
  }}
>
  <option value="Adm No">Adm No</option>
  <option value="Roll No">Roll No</option>
  <option value="Reg No">Reg No</option>
  <option value="Std Id">Std Id</option>
</select>


        <input
          type="text"
          name="AdmNo1"
          value={value.AdmNo1}
          onChange={onChange}
          placeholder="Ex: 98ZA2025"
          style={{
            flex: "2",
            minWidth: "100px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            boxSizing: "border-box",
          }}
        />
      </label>

      {error && (
        <div
          style={{
            color: "red",
            fontSize: "12px",
            marginTop: "5px",
          }}
        >
          {error}
        </div>
      )}

      <style jsx>{`
        @media (min-width: 768px) {
          div {
            flex-direction: row;
            gap: 20px;
            align-items: center;
          }
          select {
            padding: 8px;
            font-size: 0.9rem;
            width: 150px;
          }
          input {
            padding: 8px;
            font-size: 0.9rem;
            width: 200px;
          }
        }
      `}</style>
    </div>
  );
}

export default AdmNoField;